import * as React from "react";
import { Grid, Button, CardMedia, Typography } from "@mui/material";

interface ImageButtonProps {
  imageLocation: string;
  minImageSize: number;
  maxImageSize: number;
  text: string;
  fontSize: number;
  onClick(): void;
}

export default function ImageButton({
  imageLocation,
  minImageSize,
  maxImageSize,
  text,
  fontSize,
  onClick,
}: ImageButtonProps) {
  return (
    <Button
      variant="outlined"
      sx={{
        margin: "auto",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
      onClick={() => {
        onClick();
      }}
    >
      <Grid container sx={{ width: "100%" }}>
        <Grid size={3} alignContent="center">
          <img
            src={imageLocation}
            alt={text}
            style={{
              objectFit: "contain",
              minHeight: `${minImageSize}px`,
              minWidth: `${minImageSize}px`,
              maxHeight: `${maxImageSize}px`,
              maxWidth: `${maxImageSize}px`,
              height: "100%",
              width: "100%",
              margin: "auto",
            }}
          />
        </Grid>
        <Grid size={9} alignContent="center">
          <Typography
            sx={{
              color: "text.primary",
              fontSize: `${fontSize}rem`,
            }}
            align="left"
            textAlign="center"
          >
            {text}
          </Typography>
        </Grid>
      </Grid>
    </Button>
  );
}
